// extracted by mini-css-extract-plugin
export var heading = "Heading-module--heading--TOUvX";
export var headingXs = "Heading-module--headingXs--alRtF";
export var headingSm = "Heading-module--headingSm--DkfRl";
export var headingMd = "Heading-module--headingMd--pXC9S";
export var headingLg = "Heading-module--headingLg--uZymM";
export var headingXl = "Heading-module--headingXl--zWSxd";